import axios from 'axios'

class TrackTool {
  constructor(options = {}) {
    this.defaultConfig = {
      trackUrl: (process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_BASEURL) + '/xl/base/buried/point/record',
      source: '', // 来源
      maxSize: 5, // 最大缓存数量
      batchSize: 20, // 批量最大数量
      batchTimeout: 5000 // 批量时间间隔
    }
    this.config = { ...this.defaultConfig, ...options }

    Object.freeze(this.config)

    this.timer = null // 批量上报定时器

    this.init()
  }
  init() {
    const trackList = localStorage.getItem('trackList') && JSON.parse(localStorage.getItem('trackList')) || []
    if (trackList.length > 0) {
      this.startBatchTimer()
    }

    // 监听页面隐藏/显示
    this.setupVisibilityChange()

    // 页面卸载前上报
    this.setupBeforeUnload()
  }

  /**
   * 设置可见性变化监听
   */
  setupVisibilityChange() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        if (this.timer) {
          clearTimeout(this.timer);
        }
      } else if (document.visibilityState === 'visible') {
        const trackList = localStorage.getItem('trackList') && JSON.parse(localStorage.getItem('trackList')) || []
        if (trackList.length > 0) {
          this.startBatchTimer()
        }
      }
    })
  }

  /**
   * 设置页面卸载前处理
   */
  setupBeforeUnload() {
    window.addEventListener('beforeunload', () => {
      // 发送所有未发送的数据
      this.sendQueue()
    })
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }

  /**
   * 通用埋点方法
   */
  track(options = {}, eventData = {}, immediate = false) {
    let trackList = []

    if (localStorage.getItem('trackList')) {
      trackList = JSON.parse(localStorage.getItem('trackList'))
    }

    trackList.push({
      source: this.config.source,
      i: this.generateUUID(),
      v: '1', // 版本号
      b: '', // 业务ID,一种业务一个,表示一种数据结构
      c: window.$systemTime, // 产生时间戳
      s: 0, // 顺序号,一段时间内这个sid应该自动增长,核对数据是否丢失
      t: '', // 事务id,标识这是同一件事
      u: sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).userId || '', // 标识一个用户(有就填写)
      ...options,
      z: {
        ...eventData
      }
    })

    localStorage.setItem('trackList', JSON.stringify(trackList))

    if (immediate || trackList.length >= this.config.maxSize) {
      this.sendQueue()
    } else {
      this.startBatchTimer()
    }
  }

  /**
   * 开始批量上报定时器
   */
  startBatchTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    
    this.timer = setTimeout(() => {
      this.sendQueue()
    }, this.config.batchTimeout)
  }

  /**
   * 发送队列中的数据
   */
  async sendQueue() {
    let trackList = []

    if (localStorage.getItem('trackList')) {
      trackList = JSON.parse(localStorage.getItem('trackList'))
    }

    if (trackList.length > 0) {
      // 发送数据
      const sendList = trackList.slice(0, this.config.batchSize)
      axios.post(this.config.trackUrl, { log: sendList }).then(res => { 
        if (res.status === 200 && res.data.errorCode === '0000') {
          // 清空队列
          trackList.splice(0, this.config.batchSize)
          if (trackList.length > 0) {
            localStorage.setItem('trackList', JSON.stringify(trackList))
          } else {
            localStorage.removeItem('trackList')
          }
        }
      })
      
    }
  }
}

export default TrackTool